import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function ModelsValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    model_type_id: Yup.string().required(t("LABEL.required")),
    description: Yup.string()
      .min(3, t("LABEL.min"))
      .required(t("LABEL.required")),
    content: Yup.string().required(t("LABEL.required")),
  });

  return validation;
}
